import * as Yup from "yup";
import { mobilePhoneRegex,phoneRegex } from "core/common/constants/regex";

const badEmail = "כתובת המייל אינה תקינה";
export const email = Yup.string(badEmail)
  .email(badEmail)
  .required("כתובת מייל שדה חובה");

  
//positive lookahead for a small letter and a special character, and at least 8 characters
const validPassword = /^(?=.*[a-z])(?=.*[!@#$%^&*()]).{8,}$/;

const badPassword = "הסיסמה אינה תקינה";
export const password = Yup.string(badPassword)
  .matches(validPassword, badPassword)
  .typeError(badPassword)
  .max(30, badPassword)
  .required("סיסמה שדה חובה");

export const emptyPassword = Yup.string().required("סיסמה שדה חובה");

const badBusienssNumber = "מספר העסק אינו תקין";
export const businessNumber = Yup.number(badBusienssNumber)
  .typeError(badBusienssNumber)
  .positive(badBusienssNumber)
  .integer(badBusienssNumber)
  .min(4, badBusienssNumber)
  .max(9999999999, badBusienssNumber)
  .required("מספר העסק שדה חובה");

const badMobilePhoneNumber = "מספר נייד לא תקין";
export const mobilePhoneNumber = Yup.string(badMobilePhoneNumber)
  .typeError(badMobilePhoneNumber)
  .matches(mobilePhoneRegex, badMobilePhoneNumber)
  .required("מספר נייד שדה חובה");

const badPhoneNumber = "מס' טלפון לא תקין";
export const PhoneNumber = Yup.string(badPhoneNumber)
  .typeError(badPhoneNumber)
  .matches(phoneRegex, badPhoneNumber)
  .required("מס' טלפון שדה חובה");

export const reviewResponseBody = Yup.string()
  .min(1, "מינימום לפחות תו ")
  .max(1500, "מקסימום 1500 תווים")
  .required("תגובה שדה חובה");

export const validateEmail = (email) => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}
